export default {"src":"/_next/static/media/admins.d5437084.svg","height":53,"width":53};